import { AppAudioPlayer, SoundEffectKeys } from "../../audio/AppAudioPlayer";
import { TextureData, TextureStatesData } from "../../types/types";
import { ButtonEvents } from "../../ui/ButtonBase";
import { LabelButton } from "../../ui/LabelButton";
import { Padding } from "../../utils/Padding";
import { RectSize } from "../../utils/RectSize";
import { LoaderFileKeys } from "../constant/AppConstants";
import { OptionsDataManager } from "../managers/OptionsDataManager";
import { AppSettings } from "../managers/AppSettings";
import { BubbleBase } from "./BubbleBase";
import { AppTimings } from "../data/AppConstants";


export class ButtonBubble 
    extends BubbleBase
{
    public btn: LabelButton;

    protected padding: Padding;
    protected inputData: any;
    protected fontSize: number;

    protected btnTextureStatesData: TextureStatesData;
    

    public Init(
        bgTextureData: TextureData,
        bgSideWidth: number,
        tipTextureData: TextureData,
        bgEffectsPadding?: Padding,
        fontSize?: number,
        btnTextureStatesData?: TextureStatesData,
    ): void
    {
        this.btnTextureStatesData = btnTextureStatesData;

        // > contentSize
        // > totalSize
        // > contentSize
        // > origin
        super.Init(bgTextureData, bgSideWidth, tipTextureData, bgEffectsPadding);

        this.fontSize = fontSize ?? 50;
        this.padding = new Padding(50, 50);
    }

    public Build(): void
    {
        // console.log("Build");

        // > bg
        // > bgTip
        super.Build();

        // btn
        this.btn = new LabelButton(this.scene);
        this.btn.InitBase(this.btnTextureStatesData);
        this.btn.InitLabel({
                out: {
                    color: "#000",
                    fontSize: this.fontSize + "px",
                    fontFamily: AppSettings.fontFamilies.MontserratBold
                }
            }
        );
        this.btn.label.setOrigin(0.5);
        // temporary fix for our purposes (invis view, but still acts as a hitArea) 
        // - assume visually hitArea is 'the whole bubble'
        // this.btn.view.alpha = 0.0001; 
        // this.btn.view.setOrigin(0.5);
        // this.btn.view.setDisplaySize(100,50);
        this.btn.PostInit(40); // sets interactive
        // this.btn.SetRectangleHitArea(new Phaser.Geom.Rectangle(-100,-50,100,50));
        this.btn.setScale(this.baseScale);
        this.add(this.btn);

        this.bgTip.visible = false;
    }

    public SetButtonLabel(sTitle: string, updateView: boolean = false): void
    {
        this.btn.SetText(sTitle);

        if (updateView) {
            this.UpdateView();
        }
    }
    
    public override UpdateView(): void
    {
        // calculate content size
        this.contentSize.Set(
            this.padding.left + this.btn.view.displayWidth * this.btn.scale + this.padding.right,
            this.padding.top + this.btn.view.displayHeight * this.btn.scale + this.padding.bottom,
        );
        // calculate total size (content size plus embedded bg effects)
        this.totalSize.Set(
            this.bgEffectsPadding.left + this.contentSize.width + this.bgEffectsPadding.right,
            this.bgEffectsPadding.top + this.contentSize.height + this.bgEffectsPadding.bottom,
        );
        // set bg size
        this.bg.setSize(this.totalSize.width, this.totalSize.height);

        // snap bg to tip
        this.SnapBgToTip();
        
        // reposition inner content
        // txtLabel
        this.btn.setPosition(this.bg.x, this.bg.y);
    }

    protected RegisterListeners(): void
    {
        this.btn.on(ButtonEvents.CLICK, this.OnButtonClicked, this);
    }

    protected UnRegisterListeners(): void
    {
        this.btn.off(ButtonEvents.CLICK, this.OnButtonClicked);
    }
    
    /**
     * NOTE: HAS TO USE alpha, coz we additionally scale bubble itself (avoid conflict)
     */
    public override Show(animated: boolean = true): void
    {
        this.alpha = 0;
        let genericShowDuration = OptionsDataManager.GetTiming(AppTimings.genericShowDuration);
        genericShowDuration = 2000;
        if (animated) {
            this.scene.tweens.add({
                targets: this,
                alpha: 1,
                duration: genericShowDuration,
                ease: AppSettings.ease.genericShowHideEase,
            });
        }
        else {
            this.alpha = 1;
        }

        this.RegisterListeners();
        this.SetInteractive(true);
    }
    
    public override Hide(animated: boolean = true): void
    {
        let genericHideDuration = OptionsDataManager.GetTiming(AppTimings.genericHideDuration);
        genericHideDuration = 2000;
        if (animated) {
            this.scene.tweens.add({
                targets: this,
                alpha: 0,
                duration: genericHideDuration,
                ease: AppSettings.ease.genericShowHideEase,
            })
        }
        else {
            this.alpha = 0;
        }

        this.UnRegisterListeners();
        this.SetInteractive(false);
    }
    
    public SetInteractive(value: boolean): void
    {
        this.btn.SetInteractive(value);
    }

    public SetData(inputData: any): void
    {
        this.inputData = inputData;
    }

    public OnButtonClicked(): void
    {
        // button click
        AppAudioPlayer.PlaySfx(SoundEffectKeys.click5);
        
        this.Hide();
        this.inputData?.onComplete?.(this.inputData.taskType);
    }
}